<template>
  <div class="container bg1">
    <div class="row">
      <div
        class="col-md-3 col-md-offset-3 elevation-1 pa-2 text-xs-center"
        :class="{'active_user_tab elevation-6' : !freeUser}"
        @click="freeUser = false"
      >
        Paid Subscribers
      </div>
      <div
        class="col-md-3 elevation-1 pa-2 text-xs-center "
        :class="{'active_user_tab elevation-6' : freeUser}"
        @click="freeUser = true"
      >
        Free Users
      </div>
    </div>
    <h3>Users List</h3>
    <table class="
        table
        table-striped
        custom-table-width">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Subscription Type</th>
          <th>Subscription Date</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="data in freeUser ? freeUserList : paidUserList"
          :key="data.id"
        >
          <td class="custom_td">{{ data.first_name }} {{ data.last_name }}</td>
          <td class="custom_td">{{ data.email }}</td>
          <td class="custom_td">{{ data.phone }}</td>
          <td class="custom_td">{{ data.subscription ? getPlanName(data.subscription.type) : "N/A" }}</td>
          <td
            class="custom_td"
            colspan="2"
          >{{ data.subscription ? beautifyDate(data.subscription.date) : "N/A" }}
            <span
              @click="openDialog=true; currentUser = data;"
              class="ml-5"
            >
              <a class="pull-right">
                <v-icon class="pt-2 ml-4">edit</v-icon>
              </a>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <v-dialog
      v-model="openDialog"
      max-width="500px"
    >
      <v-card
        class="pa-4"
        v-if="openDialog === true"
      >
        <h3>Change details for the user</h3>
        <v-divider></v-divider>
        <p>
          <strong> Current Plan : </strong>
          {{ currentUser.subscription ? getPlanName(currentUser.subscription.type) : 'N/A' }}</p>
        <div class="form-group">
          <label for="exchange">Change Plan</label>
          <select
            class="form-control"
            v-model="currentUser.subscription_type"
            id="exchange"
          >
            <option
              v-for="plan in plans"
              :key="plan.id"
              :value="plan.id"
            >{{ plan.name }}</option>
          </select>
        </div>
        <p>
          <strong> Current Subscription Date : </strong>
          {{ currentUser.subscription ? beautifyDate(currentUser.subscription.date) : "N/A" }}</p>
        <div class="form-group">
          <label for="subscription_date">Add Change Subscription Date</label>
          <v-date-picker
            v-model="subscription_date"
            :landscape="true"
            :reactive="true"
            color="teal accent-4"
          ></v-date-picker>
        </div>
        <button
          type="submit"
          class="pa-3 admin_button"
          @click="edit"
        >Save</button>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import lb from "../../util/lb";
  import { mapGetters } from "vuex";

  export default {
    name: "UsersList",
    computed: {
      ...mapGetters(["user"])
    },
    data() {
      return {
        usersList: [],
        currentUser: {},
        subscription_date: null,
        openDialog: false,
        plans: [],
        freeUser: false,
        paidUserList: [],
        freeUserList: []
      };
    },
    mounted() {
      if (!this.user) {
        this.$router.push("/login");
        return;
      }
      if (this.user.admin != 999) {
        this.$router.push("/myaccount");
        return;
      }
      lb.get("/api/Stocks/getplanslist").then(({ data }) => (this.plans = data));
      this.getUsersList();
    },
    methods: {
      getUsersList() {
        lb.get("/api/GWSUsers", {
          params: {
            filter: {
              include: "subscription"
            }
          }
        })
          .then(({ data }) => {
            this.usersList = data;
            this.freeUserList = this.usersList.filter(item => !item.subscription);
            this.paidUserList = this.usersList.filter(item => item.subscription);
          })
          .catch(e => {
            this.$toasted.error(e.message || "Error Occured", {
              duration: 2000,
              position: "bottom-right"
            });
          });
      },
      edit() {
        if (!this.currentUser.subscription_type || !this.subscription_date) {
          this.$toasted.error("Select both plan and date", {
            duration: 2000,
            position: "bottom-right"
          });
          return;
        }
        lb.post("/api/Subscriptions/replaceOrCreate", {
          type:
            (this.currentUser &&
              this.currentUser.subcription &&
              this.currentUser.subcription.type) ||
            this.currentUser.subscription_type,
          date: this.subscription_date,
          id:
            this.currentUser &&
            this.currentUser.subcription &&
            this.currentUser.subcription.id,
          gWSUserId: this.currentUser.id
        })
          .then(({ data }) => {
            this.$toasted.show("Data Saved", {
              duration: 2000,
              position: "bottom-right"
            });
            this.openDialog = false;
            this.getUsersList();
          })
          .catch(e =>
            this.$toasted.show(e.message, {
              duration: 2000,
              position: "bottom-right"
            })
          );
      },
      getPlanName(plan) {
        const item = this.plans.find(item => item.id == plan);
        return item && item.name ? item.name : "N/A";
      },
      beautifyDate(date) {
        return date ? new Date(date).toDateString() : "N/A";
      }
    }
  };
</script>

<style lang="scss">
  .admin_button {
    color: #fff;
    background-color: #31cc9a;
    width: 100%;
  }
  .custom-table-width {
    width: 100% !important;
  }
  .custom_td {
    padding: 10px 20px !important;
  }
  .active_user_tab {
    background-color: #31cc9a;
    color: #fff;
    font-weight: 800;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/UserList.vue